import { createBuiltInComponentMeta, withComponentMeta } from '../../internal/component-meta';
import { Box as BoxComponent } from './Box';
export const Box = withComponentMeta(BoxComponent, createBuiltInComponentMeta('Box'));
//# sourceMappingURL=index.js.map